<div soho-busyindicator
     [style.height]="'100%'"
     [text]="' '"
     [blockUI]="true"
     [displayDelay]="20"
     [transparentOverlay]="true"
>
  <div>
    <div class="row form-layout-compact" *ngIf="reportType === 'ReportFromScratch'">
      <div class="one-half column">
        <div class="field">
          <label soho-label for="searchListName">{{ 'Name' | translate }}</label>
          <input
            name="searchListName"
            data-automation-id="lm-create-report-name-search"
            [(ngModel)]="searchOptions.name"
            (keydown.enter)="onNameEntered($event)"
            soho-dropdown soho-field-filter
            [fieldDropdownDataSet]="comparators"
            (filtered)="onComparatorChange($event)">
        </div>
      </div>

      <div class="one-half column">
        <div class="field">
          <label soho-label for="searchListName">{{ 'Type' | translate }}</label>
          <select
            id="item-desc" name="searchListDataType"
            [(ngModel)]="searchOptions.fieldType"
            (change)="onFieldTypeSelected()"
            soho-dropdown multiple [closeOnSelect]="false" [attributes]="typeSearchAutomationId"
            [showSelectAll]="true">
            <option *ngFor="let type of fieldTypes" [value]="type.value">{{type.label}}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="column" [ngClass]="{swapListWithoutSearchForm: reportType !== 'ReportFromScratch'}">
      <soho-swaplist
        id="lm-createreport-fields-swaplist"
        (updated)="updateItems()"
        [attributes]="fieldsAutomationId">
      </soho-swaplist>  
    </div>
    <br/>
  </div>
</div>